import type { CardsResponse } from "../../types/content";

import { BreakingCard } from "../BreakingCard/BreakingCard";
import { getMainMediaUrl } from "../Feed/utils/getMainMediaUrl";
import { InfoCard } from "../InfoCard/InfoCard";
import styles from "./Cards.module.scss";

interface CardsProps {
  isCategoryPage?: boolean;
  cards: CardsResponse;
  viewType?: "top" | "latest";
}

const Cards = ({ cards, viewType = "top" }: CardsProps) => (
  <div className={styles.container}>
    {cards.breakingCards &&
      cards.breakingCards.length > 0 &&
      cards.breakingCards.map((card, i) => (
        <BreakingCard
          articleLink={{
            articleId: card.article_id,
            slug: card.meta.promotion_content?.slug || "",
          }}
          externalLink={
            card.teaser_behaviour ? card.teaser_behaviour[0].target : undefined
          }
          vignette={card?.story_vignette?.title}
          title={card.title?.value}
          key={`${card.article_id} ${i}`}
        />
      ))}
    {cards.infoCard && (
      <InfoCard
        article={cards.infoCard}
        articleLink={{
          articleId: cards.infoCard.article_id,
          slug: cards.infoCard?.meta?.promotion_content?.slug || "",
        }}
        externalLink={
          cards.infoCard.teaser_behaviour
            ? cards.infoCard.teaser_behaviour[0].target
            : undefined
        }
        style={cards.infoCard.meta?.is_sponsored ? "native" : "regular"}
        vignette={cards.infoCard?.story_vignette?.title}
        title={cards.infoCard.title?.value}
        iconImageUrl={
          cards.infoCard.meta?.is_sponsored
            ? getMainMediaUrl(
                cards.infoCard.resources.find((r) => r.type === "Image"),
              )
            : cards.infoCard?.story_vignette?.icon_image?.url.light
        }
        key={`${cards.infoCard.article_id}`}
        viewType={viewType}
      />
    )}
  </div>
);

export { Cards };
